import { z } from "zod";

export const getPartnershipReportReferenceParamSchema = z.object({
	orgId: z.string(),
	partnershipId: z.uuid(),
	referenceId: z.uuid(),
});

export type GetPartnershipReportReferenceParamSchema = z.infer<
	typeof getPartnershipReportReferenceParamSchema
>;
